import type { PayloadAction } from '@reduxjs/toolkit';
import type { OnboardingQuestionnaireState } from '../../types';
import type {
  HydrateInsuranceExtractionPayload,
  InsuranceExtractionTypePayload,
  SetInsuranceExtractionEntryPayload,
} from './types';

export function createOnboardingInsuranceReducers() {
  return {
    setInsuranceExtractionEntry,
    clearInsuranceExtractionEntry,
    markInsuranceExtractionReviewed,
    hydrateInsuranceExtraction,
  };

  function setInsuranceExtractionEntry(
    state: OnboardingQuestionnaireState,
    action: PayloadAction<SetInsuranceExtractionEntryPayload>,
  ) {
    state.insuranceExtraction[action.payload.insuranceType] = action.payload.entry;
  }

  function clearInsuranceExtractionEntry(
    state: OnboardingQuestionnaireState,
    action: PayloadAction<InsuranceExtractionTypePayload>,
  ) {
    state.insuranceExtraction[action.payload.insuranceType] = null;
  }

  function markInsuranceExtractionReviewed(
    state: OnboardingQuestionnaireState,
    action: PayloadAction<InsuranceExtractionTypePayload>,
  ) {
    const entry = state.insuranceExtraction[action.payload.insuranceType];
    if (entry) {
      entry.reviewedAfterCompletion = true;
    }
  }

  function hydrateInsuranceExtraction(
    state: OnboardingQuestionnaireState,
    action: PayloadAction<HydrateInsuranceExtractionPayload>,
  ) {
    state.insuranceExtraction = action.payload.map;
  }
}
